import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkpaperProcedureResult } from '../types/workpaper-procedure';
import { isMock } from '../utilities/is-mock';

export type GetWorkpapersProceduresResponse = {
    workpaperProcedures: WorkpaperProcedureResult[];
};

type UseProceduresConfig = {
    search?: string;
    sort?: string;
    filter?: string;
    searchFilters?: string;
};

async function getWorkpaperProcedures(
    workpaperId: string,
    { search, sort, filter, searchFilters }: UseProceduresConfig
): Promise<GetWorkpapersProceduresResponse> {
    const query = isMock() ? `?filter=${filter}&search=${search}&sort=${sort}` : `?${filter}&search=${search}&${sort}&${searchFilters}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/procedures${query}`);
    return data;
}
export function useWorkpaperProcedures(
    workpaperId: string,
    { search, sort, filter, searchFilters }: UseProceduresConfig
): UseQueryResult<GetWorkpapersProceduresResponse, unknown> {
    return useQuery(
        ['workpapers', workpaperId, 'procedures', search, sort, filter],
        () => getWorkpaperProcedures(workpaperId, { search, sort, filter, searchFilters }),
        {
            keepPreviousData: true,
            enabled: filter !== undefined && sort !== undefined,
        }
    );
}
